import React, { useState } from "react";
import TelecallingOrderTracking from "./telecalling";
import AssignService from "./AssignService";
import TicketEnquiry from "./TicketEnquiry";
import WarrentyApproval from "./WarrentyApproval";
import VisitorsList from "./VisitorsList";

const TeleCall = () => {
    const [activeTab, setActiveTab] = useState("TeleCalling");
const [selectedRecord, setSelectedRecord] = useState(null);

    const tabs = [
        "TeleCalling",
        "AssignService",
        "TicketEnquiry",
        "WarrentyApproval", 
        "VisitorsList",
    ];

    return (
        <div style={styles.wrapper}>
            {/* ---------- TABS ---------- */}
            <div style={styles.tabs}>
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                            ...styles.tabBtn,
                            borderBottom:
                                activeTab === tab ? "2px solid #005487" : "none",
                            color: activeTab === tab ? "#005487" : "#333",
                        }}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* ---------- TAB CONTENT ---------- */}
            {activeTab === "TeleCalling" && <TelecallingOrderTracking />}
            {activeTab === "AssignService" && <AssignService setActiveTab={setActiveTab}     setSelectedRecord={setSelectedRecord}/>}
            {activeTab === "TicketEnquiry" && <TicketEnquiry record={selectedRecord}/>}
            {activeTab === "WarrentyApproval" && <WarrentyApproval />}
            {activeTab === "VisitorsList" && <VisitorsList />}
        </div>
    );
};

export default TeleCall;

/* ---------- STYLES ---------- */
const styles = {
    wrapper: {
        background: "#fff",
        padding: "15px",
        borderRadius: "6px",
    },

    tabs: {
        display: "flex",
        borderBottom: "1px solid #ddd",
        marginBottom: "15px",
        overflowX: "auto",
    },

    tabBtn: {
        background: "none",
        border: "none",
        padding: "10px 16px",
        cursor: "pointer",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },
};
